import {
  ChangeDetectorRef,
  DestroyRef,
  Directive,
  EmbeddedViewRef,
  inject,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FeatureFlagService } from '@core/feature-flag/feature-flag.service';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[featureFlags]',
  standalone: true
})
export class FeatureFlagsDirective implements OnInit {
  @Input()
  featureFlags: string;
  @Input()
  set featureFlagsElse(templateRef: TemplateRef<any> | null) {
    this.elseTpl = templateRef;
  }

  private _destroyRef = inject(DestroyRef);

  private elementViewRef: EmbeddedViewRef<any>;
  private elseTpl: TemplateRef<any>;

  constructor(
    private _vcr: ViewContainerRef,
    private _cdRef: ChangeDetectorRef,
    private _tpl: TemplateRef<any>,
    private _featureFlagsService: FeatureFlagService
  ) {}

  private showElement(tpl: TemplateRef<any>): void {
    this._vcr.clear();
    this.elementViewRef = null;

    this.elementViewRef = this._vcr.createEmbeddedView(tpl);
    this._cdRef.markForCheck();
  }

  private hideElement(): void {
    this._vcr.clear();
    this.elementViewRef = null;
    if (this.elseTpl) {
      this.elementViewRef = this._vcr.createEmbeddedView(this.elseTpl);
      this._cdRef.markForCheck();
    }
  }

  ngOnInit(): void {
    this._featureFlagsService
      .hasFlag(this.featureFlags)
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        map((hasFlags) => {
          hasFlags ? this.showElement(this._tpl) : this.hideElement();
        })
      )
      .subscribe();
  }
}
